import React from 'react';
import './UniversityPage.css';

const UniversityPage9 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Parma</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The University of Parma (Università degli Studi di Parma) is one of Italy's oldest and most respected educational institutions, founded in 962. Located in the historic city of Parma in northern Italy, it offers a wide range of undergraduate, graduate, and doctoral programs across various disciplines, including humanities, sciences, engineering, economics, law, and medicine. The university is known for its commitment to research, innovation, and quality teaching.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of UniPR</h2>
                    <p>The University of Parma is ranked in the QS World University Rankings between 951-1000 globally and above 500 in the field of medicine.</p>
                </section>

                <section className="seats-available">
                    <h2>Seats Available</h2>
                    <p>For the 2024 IMAT intake, the University of Parma has allocated a total of 120 seats for its Medicine and Surgery program. Of these, 75 seats are available for EU students, while 45 seats are reserved for non-EU students. These seats are open to those who successfully pass the IMAT exam and meet all other admission requirements.</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Non-EU Seats</th>
                                    <th>EU Seats</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>45</td>
                                    <td>75</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Scores in Past Years and Cut-offs</h2>
                    <p>Below are the IMAT scores and cut-offs for the past few years:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Minimum Score (Non-European)</th>
                                    <th>European Scores (First/Last Round)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2021</td>
                                    <td>35.5</td>
                                    <td>First: 44.5 / Last: 35.0</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>41.9</td>
                                    <td>First: 44.4 / Last: 34.1</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>50.1</td>
                                    <td>First: 37.6 / Last: 35.3</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>59.1</td>
                                    <td>First: 60.3 / Last: 57.6</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>Prospective students must meet the following requirements:</p>
                    <ul>
                        <li>A high school diploma equivalent to the Italian secondary school qualification. Minimum score should be 70%.</li>
                        <li>A valid IMAT score above the cutoff for their category (EU/non-EU).</li>
                        <li>Proof of English proficiency (for non-native speakers).</li>
                        <li>Visa and residence permit for non-EU students.</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Subjects Taught</h2>
                    <p>The Medicine and Surgery program at the University of Parma follows a 6-year course structure, divided into three main stages. The program provides a comprehensive education in medical sciences, clinical practice, and patient care.</p>

                    <h3>First Year</h3>
                    <ul>
                        <li>Physico-Chemical Bases of Life</li>
                        <li>Cells & Tissues</li>
                        <li>Statistics, Research Methodology & Safety Regulation</li>
                        <li>Molecular Biology, Genetics & Genomics</li>
                        <li>ADE</li>
                    </ul>

                    <h3>Second Year</h3>
                    <ul>
                        <li>Human Physiology</li>
                        <li>Immunology & Microbiology</li>
                        <li>Medical Humanities</li>
                        <li>Disease Pathophysiology</li>
                        <li>Clinical Microbiology & Infectious Diseases</li>
                        <li>Pharmacology</li>
                        <li>Biomedical Research Clerkship</li>
                    </ul>

                    <h3>Third Year</h3>
                    <ul>
                        <li>Laboratory Medicine & Immunogenetics</li>
                        <li>Endocrine & Metabolic & Gastrointestinal Diseases</li>
                        <li>Neurological Sciences</li>
                        <li>Psychiatry</li>
                        <li>Hematology & Oncology</li>
                        <li>Respiratory Diseases & Allergology</li>
                        <li>Cardiovascular Diseases & Basic Life Support</li>
                        <li>Biomedical Technologies & Imaging</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <ul>
                        <li>Clinical Immunology & Rheumatology</li>
                        <li>Nephrology & Urology</li>
                        <li>Musculoskeletal Diseases</li>
                        <li>Rehabilitation Medicine</li>
                        <li>Dermatology & Plastic Surgery</li>
                        <li>Geriatrics & Functional Patient Management</li>
                        <li>Head & Neck</li>
                        <li>Clinical Surgery & Emergency Medicine</li>
                        <li>Medicine & Surgery Clerkship 1 (Clinical Rotation 1)</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <ul>
                        <li>Pediatrics</li>
                        <li>Obstetrics & Gynaecology</li>
                        <li>Pathology</li>
                        <li>Forensic & Occupational Medicine</li>
                        <li>ADE</li>
                        <li>Public Health, International Health Systems & Economics</li>
                        <li>Internal Medicine, Clinical Pharmacology</li>
                        <li>Clinical Risk Management</li>
                        <li>Medicine & Surgery Clerkship 2 (Clinical Rotation 2)</li>
                        <li>ADE</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Medicine & Surgery Clerkship 3 (Clinical Rotation 3)</li>
                        <li>Thesis</li>
                        <li>Licensing Internship in Internal Medicine</li>
                        <li>Licensing Internship in Surgery</li>
                        <li>Licensing Internship in Community Medicine</li>
                        <li>Thesis</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams</h2>
                    <p>The Medicine and Surgery program at the University of Parma follows a rigorous system of exams to assess students’ progress throughout their 6 years of study.</p>
                    <p><strong>First to Fifth Years:</strong></p>
                    <ul>
                        <li><strong>Written exams:</strong> These typically consist of multiple-choice questions or short-answer questions to test theoretical knowledge in subjects like Anatomy, Physiology, Pharmacology, etc.</li>
                        <li><strong>Oral exams:</strong> After written exams, students often have an oral component where they discuss the material in-depth with the examiners. This is common for clinical subjects like Internal Medicine, Surgery, and Pathology.</li>
                        <li><strong>Practical exams:</strong> In clinical subjects, students must demonstrate their skills in practical settings. This can include performing basic medical procedures, taking patient histories, or interpreting lab results.</li>
                    </ul>
                    <p><strong>Sixth Year:</strong></p>
                    <ul>
                        <li>The final year is more focused on clinical internships, where students are evaluated based on their performance in hospitals and medical settings.</li>
                        <li><strong>State exam (Esame di Stato):</strong> At the end of the program, students must pass the State exam to qualify for practicing medicine in Italy. This exam involves both written and oral components, and a final assessment of clinical competence.</li>
                    </ul>
                </section>

                <section className="tuition-fees">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p>Students should pay 156 euros (regional tax 140 euros and virtual stamp 16 euros).</p>
                    <p><strong>Scholarships:</strong> Managed by <strong>Emilia Romagna</strong>. <a href="https://www.er-go.it/">ER-GO Scholarships</a></p>
                    <p>Scholarships are financial support, provided on a competitive basis. The scholarship application must be submitted annually within the deadline stipulated in the announcement. Scholarships are announced at the regional level and the university level.</p>
                </section>

                <section className="city-info">
                    <h2>Parma as a City</h2>
                    <p>Parma is a charming city in northern Italy, known for its rich history, culture, and world-famous cuisine. It offers a perfect blend of tradition and modernity, with beautiful architecture, historic sites, and a lively student atmosphere. The city is home to stunning landmarks like the Palazzo della Pilotta, Parma Cathedral, and the Teatro Regio, a renowned opera house. Parma is also internationally celebrated for its food, being the birthplace of Parmesan cheese and Parma ham (Prosciutto di Parma).</p>
                    <p>With a welcoming and safe environment, excellent public transport, and a relaxed lifestyle, Parma is an ideal place for students. It provides all the amenities of a big city while maintaining a peaceful and picturesque atmosphere, making it a great place to live and study.</p>
                </section>

                <section className="living-expenses">
                    <h2>Living Expenses and International Life in Parma</h2>
                    <ul>
                        <li><strong>Cost of living:</strong> Shared apartments range from €300-800 per month depending on location and amenities.</li>
                        <li><strong>Food and dining:</strong> Weekly grocery expenses average €40-60.</li>
                        <li><strong>Transportation:</strong> Monthly adult bus-pass: €28.50.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>Living in Parma as a medical student offers a balanced mix of academic rigor and an enriching lifestyle. The city provides an affordable cost of living compared to larger Italian cities, with student-friendly housing options and convenient public transport. With its rich cultural heritage, historic architecture, and world-famous cuisine, Parma offers a welcoming and comfortable environment for students. The University of Parma ensures strong clinical training opportunities in well-equipped hospitals, preparing students for real-world medical practice. Overall, studying medicine in Parma combines high-quality education with a vibrant student life, making it a great choice for aspiring doctors.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage9;